import React, { useMemo } from 'react';
import Grid from '@mui/material/Grid';
import { BoxCard } from '../../index';

export const ReportToolsCards = ({
  title = 'Total',
  totalReportData,
  toolsNamesMap = {},
}) => {
  const totalCount = useMemo(
    () => Object.keys(toolsNamesMap).length ? totalReportData?.total?.count : totalReportData?.count,
    [toolsNamesMap]
  );

  return (
    <>
      <Grid
        container
        spacing={2}
        sx={{
          mt: 2,
          alignItems: "stretch"
        }}>
        <Grid size={{ xs: 6, sm: 4, md: 3, lg: 1.9 }}>
          <BoxCard
            useFlex
            title={title}
            value={totalCount || 0}
            borderColor="rgb(44,56,197)"
          />
        </Grid>
      </Grid>
    </>
  );
};
